/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum FrameOverlaysType {
    RollerShutters = 0,
    RollerBlinds = 1,
    InsectScreens = 2,
    FrameVentilationSystem = 3,
    InsideShading = 4,
    InvisibleObject = 5,
}
